module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/pages/home/home.component.scss
// module id = ./src/app/main/content/pages/home/home.component.scss
// module chunks = main